import React from "react";
import { Grid } from "@mui/material";
import TotalGuidingErrorChart from "./TotalGuidingErrorChart";
import RaDecErrorChart from "./RaDecErrorChart";
import GuidingErrorVsHfrChart from "./GuidingErrorVsHfrChart";
import GuidingQualityDistributionChart from "./GuidingQualityDistributionChart";
import { ImageMetadata } from "../types";

interface GuidingTabPanelProps {
  imagesForView: ImageMetadata[];
}

const GuidingTabPanel: React.FC<GuidingTabPanelProps> = ({ imagesForView }) => {
  // Only use light frames for guiding charts
  const lightFrames = imagesForView.filter((img) =>
    img.FrameType ? img.FrameType === "LIGHT" : !!img.FilterName
  );
  return (
    <Grid container spacing={3}>
      {/* Total Guiding Error */}
      <Grid size={{ xs: 12, md: 6 }}>
        <TotalGuidingErrorChart imagesForView={lightFrames} />
      </Grid>
      {/* RA vs DEC Error */}
      <Grid size={{ xs: 12, md: 6 }}>
        <RaDecErrorChart imagesForView={lightFrames} />
      </Grid>
      {/* Guiding Error vs HFR */}
      <Grid size={{ xs: 12, md: 6 }}>
        <GuidingErrorVsHfrChart imagesForView={lightFrames} />
      </Grid>
      {/* Guiding Quality Distribution */}
      <Grid size={{ xs: 12, md: 6 }}>
        <GuidingQualityDistributionChart imagesForView={lightFrames} />
      </Grid>
    </Grid>
  );
};

export default GuidingTabPanel;
